export default __webpack_public_path__ + "static/media/image4.bb065ff9.avif";